<script setup>
import {Gender, GenderLabel} from "@/choices";
import {mdiGenderFemale, mdiGenderMale} from "@mdi/js";
import SelectionButtonsInput from "@/components/forms/SelectionButtonsInput.vue";
import SelectionButton from "@/components/forms/SelectionButton.vue";

const gender = defineModel({type: String});
const props = defineProps({
    fieldProps: {
        type: Object,
    },
});
const emit = defineEmits(['submit']);

function submit() {
    emit('submit', gender.value);
}
</script>

<template>
    <main>
        <h1>{{ pgettext('label', 'Male or female?') }}</h1>

        <SelectionButtonsInput v-model="gender" v-bind="fieldProps" size="x-large" :height="72" @select="submit()">
            <SelectionButton :value="Gender.MALE" color="blue" :prepend-icon="mdiGenderMale">
                <strong>{{ GenderLabel[Gender.MALE] }}</strong>
            </SelectionButton>
            <SelectionButton :value="Gender.FEMALE" color="red-darken-1" :prepend-icon="mdiGenderFemale">
                <strong>{{ GenderLabel[Gender.FEMALE] }}</strong>
            </SelectionButton>
        </SelectionButtonsInput>

        <p v-if="gender" class="text-center mt-4">
            <v-btn color="green" size="large" @click="submit()">
                <strong>{{ pgettext('action', 'Continue') }}</strong>
            </v-btn>
        </p>
        <p v-else class="text-center text-subtitle-2">
            {{ gettext('To continue, please select one of the options.') }}
        </p>
    </main>
</template>
